import React from 'react'
import { ReactComponent as Error } from 'style/icons/404.svg'
import { Button, Result } from 'antd'
import { globalHistory, Router, Link } from '@reach/router'
import { QueryParamProvider } from 'use-query-params'
import Dashboard from 'views/Dashboard'
import Administration from 'views/Administration'
import PaymentRequired from 'views/PaymentRequired'
import UserManagement from 'views/UserManagement'
import ScanSettings from 'views/ScanSettings'
import Login from 'views/PreLogin/Login'
import GlobalSettings from 'views/GlobalSettings'
import RecoverPassword from 'views/PreLogin/RecoverPassword'
import ResetPassword from 'views/PreLogin/ResetPassword'
import CreateAccount from 'views/PreLogin/CreateAccount'
import UserSignUp from 'views/PreLogin/SignUp'
import CreateAccountFrame from 'views/PreLogin/CreateAccount/Iframe'


export const AuthenticatedRoutes = () => {
	return (
			<QueryParamProvider reachHistory={globalHistory}>
				<Router>
					<Dashboard path="/dashboard" />
					<ScanSettings path="/scan-settings/*" />
					<GlobalSettings path="/global-settings" />
					<UserManagement path="/account-management/*" />
					<Administration path="/administration/*" />
					<PaymentRequired path="/payment-required"/>
					<Result
						default
						icon={<Error width={360} height={360} />}
						title="404"
						subTitle="Sorry, the page you visited does not exist."
						extra={
							<Link to="/scan-settings">
								<Button type="primary">Back Home</Button>
							</Link>
						}
					/>
				</Router>
			</QueryParamProvider>
	)
}

export const UnAuthenticatedRoutes = () => {
	return (
		<Router>
			<Login path="/sign-in" default />
			<RecoverPassword path="/recover-password" />
			<ResetPassword path="/reset-password" />
			<UserSignUp path="/user-sign-up" />
			<CreateAccount path="/sign-up" />
			<CreateAccountFrame path="/create-account-frame" />
		</Router>
	)
}
